/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.span-open[_ngcontent-%COMP%] {\n  color: #ffffff;\n  background: #28a745;\n  font-style: oblique;\n  padding: 2px 10px 2px 10px;\n  border-radius: 5px; }\n\n.span-close[_ngcontent-%COMP%] {\n  color: #ffffff;\n  background: #ffc107;\n  font-style: oblique;\n  padding: 2px 10px 2px 10px;\n  border-radius: 5px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvb3BlbmluZy1zdGF0aW9ucy9vcGVuaW5nLXN0YXRpb24vb3BlbmluZy1zdGF0aW9uLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC9tb2R1bGVzL2VtcGxveWVlL3BhZ2VzL29wZW5pbmctc3RhdGlvbnMvb3BlbmluZy1zdGF0aW9uL29wZW5pbmctc3RhdGlvbi5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/opening-stations/opening-station/opening-station.component.scss.shim.ngstyle.ts